import * as React from "react";

export const IconDeleteCompanyItem = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="10" cy="10" r="8" fill="white" />
    <path
      d="M15.2459 5.93047C15.5704 5.606 15.5704 5.07994 15.2459 4.75547C14.9214 4.431 14.3954 4.431 14.0709 4.75547L10.0001 8.8263L5.92925 4.75547C5.60478 4.431 5.07872 4.431 4.75425 4.75547C4.42978 5.07994 4.42978 5.606 4.75425 5.93047L8.82508 10.0013L4.75425 14.0721C4.42978 14.3966 4.42978 14.9227 4.75425 15.2471C5.07872 15.5716 5.60478 15.5716 5.92925 15.2471L10.0001 11.1763L14.0709 15.2471C14.3954 15.5716 14.9214 15.5716 15.2459 15.2471C15.5704 14.9227 15.5704 14.3966 15.2459 14.0721L11.1751 10.0013L15.2459 5.93047Z"
      fill="#767B7E"
    />
  </svg>
);
